import React from "react";
import { Container } from "react-bootstrap";

const SiteHeader = ({ showText }: any): JSX.Element => {
  return (
    <div className="header-container">
      <Container>
        <h4 className="text-center py-3 m-0 ">{showText}</h4>
      </Container>
    </div>
  );
};

export default SiteHeader;
